export interface PaginationEdge<Item = any> {
  cursor: string;
  item: Item;
}

export interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

export interface PaginationConnection<Item = any> {
  totalCount: number;
  list: PaginationEdge<Item>[];
  pageInfo: PageInfo;
}

export interface Pagination<Schema> {
  list: Schema;
}

export interface VerificationForm {
  email: string;
  otpCode: string;
  expiredTime?: Date;
  fromPage?: string;
  password?: string;
}

export interface SignUpForm {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmationPassword: string;
  countryCode: string;
  phone: string;
  phoneCode?: string;
  isAgree?: boolean;
  subscribeNewsletter?: boolean;
}

export enum UserAction {
  ADD = 'add',
  UPDATE = 'update',
  DELETE = 'delete',
}

export interface PaginatedQueryParams {
  searchValue?: string;
  page?: number;
  pageSize?: number;
  order?: [string, string][];
}

export interface PaginatedConnection<Item = any> {
  totalCount: number;
  list: Item[];
  page: number;
}

export enum ActionPaginate {
  Next = 'next',
  Previous = 'previous',
}

export enum EntityTypes {
  product = 'product',
  chemical = 'chemical',
}
